<template>
  <div class="footer">
    <span>© 2018</span>
    <a href="javascript:;">XX集团 移动开放平台</a> |
    <a href="javascript:;">服务协议</a> |
    <a href="javascript:;">权利声明</a> |
    <a href="javascript:;">版本更新</a> |
    <a href="javascript:;">帮助中心</a> |
    <a href="javascript:;">版权投诉</a>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    height: 40px;
    text-align: center;
    color: #c8c8c8;
    font-size: 12px;
    border-top: 1px solid #c8c8c8;
    a {
      display: inline-block;
      text-decoration: none;
      color: #c8c8c8;
      margin: 12px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue